<template lang="pug">
UiModal(
  :show="show"
  @close="close"
  :title="$t('companies.vendors.replacement_account_list')"
  :rightActions="rightActions"
  width="1000"
)
  UiStack(vertical)
    UiStackItem
      a(
        href="/replacement_codes.xlsx"
        target="_blank"
      ) {{ $t("companies.file_example") }}
    UiStackItem
      UiFilePicker(
        v-model="replacementFile"
        placeholder="Choose a file or drop it here..."
        :extensions="['xlsx']"
      )
    UiStackItem
      UiStack
        UiButton(
          :disabled="!Boolean(replacementFile)"
          @click="uploadReplacementFile"
          icon="FileUpload"
          variant="smooth-primary"
        ) {{ $t("actions.upload") }}
        UiButton(
          @click="clearReplacementFile"
          icon="Trash"
          variant="smooth-danger"
          :disabled="isEmpty"
        ) {{ $t("actions.delete") }}
    UiStackItem
      RestTable(
        namespace="replacement_codes"
        :embed="true"
        :headers="replacement_headers"
        :fetch-handler="getData"
        :itemsPerPageAttachDropdownToBody="false"
        ref="vendorReplacementListTable"
      )
</template>

<script>
import ApiCompanyAccountKeyword from "@/api/companyAccountKeyword.js";
import ApiCompanyFeatures from "@/api/companyFeatures.js";

export default {
  data() {
    return {
      isEmpty: true,
      show: false,
      replacementFile: null,
      replacement_headers: [
        {
          key: "old_code",
          label: "Old code",
          squeeze: false,
        },
        {
          key: "new_code",
          label: "New code",
          squeeze: false,
        },
      ],
    };
  },

  computed: {
    rightActions() {
      return [
        {
          label: this.$t("actions.confirm"),
          onClick: this.close,
        },
      ];
    },
  },

  methods: {
    reloadList() {
      this.$refs.vendorReplacementListTable.fetchData();
    },

    open(companyId, Vendor) {
      this.companyId = companyId;
      this.vendorId = Vendor.id;
      this.isEmpty = true;
      this.show = true;
    },

    close() {
      this.show = false;
    },

    getData(params, config) {
      return ApiCompanyAccountKeyword.fetchReplacementList(
        this.companyId,
        { vendor_id: this.vendorId, ...params },
        config,
      ).then((resp) => {
        this.isEmpty = !resp.data?.replacement_codes?.length;
        return {
          items: resp.data.replacement_codes,
          meta: resp.data.meta,
        };
      });
    },

    uploadReplacementFile() {
      let formData = new FormData();
      formData.append("file", this.replacementFile);
      formData.append("vendor_id", this.vendorId);
      ApiCompanyFeatures.uploadReplacementFile(formData)
        .then((resp) => {
          this.replacementFile = null;
          this.reloadList();
          this.$emit("done");
        })
        .catch((e) => {});
    },

    clearReplacementFile() {
      let formData = new FormData();
      formData.append("vendor_id", this.vendorId);
      ApiCompanyFeatures.clearReplacementFile(formData)
        .then((resp) => {
          this.replacementFile = null;
          this.reloadList();
          this.$emit("done");
        })
        .catch((e) => {});
    },
  },
};
</script>
